(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["free-shipping-bar"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {

  document.addEventListener('updateShippingBar', function() {
    const shippingBar = document.querySelector('.free-shipping-bar');
    console.log('shipping event');
    if (!shippingBar) return;

    // Check if the bar is currently visible
    const isVisible = shippingBar.getAttribute('data-visible') === 'true';

    if (!isVisible) {
      // If the bar is not visible, run the entry animation
      shippingBar.setAttribute('data-visible', 'true');

      shippingBar.animate([
        { top: '-60px' },
        { top: '0' }
      ], {
        duration: 300,
        easing: 'ease-in-out',
        fill: 'forwards'
      });
    }

    // Clear any previous exit timeouts and set a new one
    clearTimeout(shippingBar.exitTimeout);
    shippingBar.exitTimeout = setTimeout(() => {
      shippingBar.setAttribute('data-visible', 'false');
      shippingBar.animate([
        { top: '0' },
        { top: '-60px' }
      ], {
        duration: 300,
        easing: 'ease-in-out',
        fill: 'forwards'
      });
    }, 8000); // 8 seconds

  });

  // Trigger the updateShippingBar event on initial page load
  document.dispatchEvent(new Event('updateShippingBar'));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-finder"] && !window.DesignMode) return;
  try {
    

var submitButton = document.querySelector('#gift-search input[type="submit"]');

function checkSelections() {
  var tagAValue = document.getElementById('tagA').value;
  var tagBValue = document.getElementById('tagB').value;
  var tagCValue = document.getElementById('tagC').value;

  if (tagAValue !== "" || tagBValue !== "" || tagCValue !== "") {
    submitButton.disabled = false;
  } else {
    submitButton.disabled = true;
  }
}

document.getElementById('tagA').addEventListener('change', checkSelections);
document.getElementById('tagB').addEventListener('change', checkSelections);
document.getElementById('tagC').addEventListener('change', checkSelections);


document.getElementById("gift-search").addEventListener("submit", function(event) {
    event.preventDefault();

    const tagA = document.getElementById('tagA').value ? 'tag%3A' + document.getElementById('tagA').value : '';
    const tagB = document.getElementById('tagB').value ? 'tag%3A' + document.getElementById('tagB').value : '';
    const tagC = document.getElementById('tagC').value ? 'tag%3A' + document.getElementById('tagC').value : '';

    let searchParams = [tagA, tagB, tagC].filter(Boolean).join('+AND+');
    
    window.location.href = '/search?sort_by=relevance&q=' + searchParams;
    console.log(searchParams);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-search-row"]) return;
  try {
    
document.querySelector('.drilldown-icon').addEventListener('click', function(e) {
  const backdrop = document.querySelector('drilldown-menu');
  const menu = document.querySelector('.menu-container');

  backdrop.classList.remove('closed');
  document.body.classList.add('fixed-position');
  setTimeout(() => menu.style.right = '0', 120);
});

document.querySelector('#closeButton').addEventListener('click', function() {
  const backdrop = document.querySelector('drilldown-menu');
  const menu = document.querySelector('.menu-container');

  menu.style.right = '-80vw';
  document.body.classList.remove('fixed-position');
  setTimeout(() => backdrop.classList.add('closed'), 120);
});

document.querySelector('drilldown-menu').addEventListener('click', function(e) {
  if(e.target !== e.currentTarget) return;
  if(e.target.classList.contains('closed')) return;
  const backdrop = document.querySelector('drilldown-menu');
  const menu = document.querySelector('.menu-container');
  menu.style.right = '-80vw';
  document.body.classList.remove('fixed-position');
  setTimeout(() => backdrop.classList.add('closed'), 120);
});
$(document).ready(function() {
  $('.is-drilldown-submenu-parent > a').click(function() {
    $('.is-active').removeClass('is-active');
    $(this).next('ul').addClass('is-active');
  });
  
  $('.js-drilldown-back > a').click(function() {
    $('.is-active').removeClass('is-active');
  });
});

function waitForWishlistSDK(callback, maxAttempts = 20) {
  let attempts = 0;
  
  const checkSDK = () => {
    attempts++;
    if (window.WishListHero_SDK) {
      callback();
    } else if (attempts < maxAttempts) {
      setTimeout(checkSDK, 500);
    } else {
      console.warn('WishListHero SDK not loaded after maximum attempts');
    }
  };
  
  checkSDK();
}

function updateWishlistCount() {
  waitForWishlistSDK(() => {
    try {
      const count = window.WishListHero_SDK.GetWishListItemsCount();
      const countElement = document.querySelector('.wishlist-count');
      if (countElement) {
        if (count > 0) {
          countElement.textContent = count;
          countElement.style.display = 'block';
        } else {
          countElement.style.display = 'none';
        }
      }
    } catch (error) {
      console.error('Error fetching wishlist count:', error);
    }
  });
}

// Add click listeners for wishlist buttons
function setupWishlistListeners() {
  // For collection page buttons
  document.addEventListener('click', function(e) {
    if (e.target.matches('.wishlist-hero-custom-button') || 
        e.target.closest('.wishlist-hero-custom-button') ||
        e.target.matches('#wishlisthero-product-page-button-container button') ||
        e.target.closest('#wishlisthero-product-page-button-container button')) {
      setTimeout(updateWishlistCount, 500);
    }
  });

  // Add wishlist button click handler
  document.querySelector('#wishlist-button').addEventListener('click', function(e) {
    e.preventDefault(); // Prevent default link behavior
    waitForWishlistSDK(() => {
      window.WishListHero_SDK.OpenWishList();
    });
  });
}

// Initialize everything when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  updateWishlistCount();
  setupWishlistListeners();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner-gf"] && !window.DesignMode) return;
  try {
    
console.log('ready for search');
var submitButton = document.querySelector('#gift-search input[type="submit"]');
  
function checkSelections() {
  var tagAValue = document.getElementById('tagA').value;
  var tagBValue = document.getElementById('tagB').value;
  var tagCValue = document.getElementById('tagC').value;

  if (tagAValue !== "" || tagBValue !== "" || tagCValue !== "") {
    submitButton.disabled = false;
    submitButton.value = "Find Gifts";
  } else {
    submitButton.disabled = true;
    submitButton.value = "Select your options";
  }
}

document.getElementById('tagA').addEventListener('change', checkSelections);
document.getElementById('tagB').addEventListener('change', checkSelections);
document.getElementById('tagC').addEventListener('change', checkSelections);

checkSelections();
  
document.getElementById("gift-search").addEventListener("submit", function(event) {
    event.preventDefault();

    const tagA = document.getElementById('tagA').value ? 'tag%3A%27' + document.getElementById('tagA').value + '%27' : '';
    const tagB = document.getElementById('tagB').value ? 'tag%3A%27' + document.getElementById('tagB').value + '%27' : '';
    const tagC = document.getElementById('tagC').value ? 'tag%3A%27' + document.getElementById('tagC').value + '%27' : '';

    let searchParams = [tagA, tagB, tagC].filter(Boolean).join('+AND+');

    console.log('searching... ', searchParams);
    window.location.href = '/search?sort_by=relevance&q=' + searchParams;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
$(document).ready(function() {
  $.fn.extend({
    toggleText: function(a, b){
      return this.text(this.text() == b ? a : b);
    }
  });

  // On document ready, check each button and its corresponding content
  $('.subpage-readmore-btn').each(function() {
    var descriptionDiv = $(this).prev('.collection-hero__description');
    // If the content of the div is overflowing...
    if (descriptionDiv[0].scrollHeight > descriptionDiv.height() - 30) {
      // Show this button
      $(this).show();
    }
  });

  $('.subpage-readmore-btn').click(function(e) {
    e.preventDefault();
    var descriptionDiv = $(this).prev('.collection-hero__description');
    descriptionDiv.toggleClass('expanded');
    $(this).toggleText('Read More', 'Read Less');

    // If the expanded class is currently applied...
    if (!descriptionDiv.hasClass('expanded')) {
      // Smoothly scroll the page back to the title element
      $('html, body').animate({
        scrollTop: ($('#desc_title').offset().top - 220)
      }, 200);
    }
  });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
/**console.log('Collection - v1.0382');
const minusButtons = document.querySelectorAll(".button-minus-qty");
const plusButtons = document.querySelectorAll(".button-plus-qty");
const checkoutButtons = document.querySelectorAll(".quick-add__submit");

minusButtons.forEach(button => {
  button.addEventListener("click", handleButtonClick);
});

plusButtons.forEach(button => {
  button.addEventListener("click", handleButtonClick);
});

checkoutButtons.forEach(button => {
  button.addEventListener("click", handleButtonClick);
});

function handleButtonClick(event) {
  event.preventDefault();
  let variantId = parseInt(event.target.getAttribute('data-vid'));
  let newQty = event.target.getAttribute('data-qty');
  let submitButton;

  console.log("Event target: ", event.target);
  console.log("Variant ID: ",variantId);
  console.log("New quantity to pass: ", newQty);

  let errorBox = document.querySelector(`.product-form__error-message-wrapper-${variantId}`);
  let errorText = errorBox.querySelector(".product-form__error-message");
  errorBox.classList.add("hidden");
  errorBox.setAttribute("hidden","");
  errorText.innerHTML = "";

  if(event.target.id == 'minus-qty' || event.target.id == 'plus-qty' ) {
    cartRoute = routes.cart_change_url;
    submitButton = event.target.closest('.quick-add').querySelector('.quick-add__submit');
  } else {
    submitButton = event.target;
    if(newQty == 1) {
      cartRoute = routes.cart_add_url;
    } else {
      cartRoute = routes.cart_change_url;
    }
  }
  console.log("SUBMIT: ", submitButton);
  submitButton.classList.add("loading");
  submitButton.querySelector('.loading-overlay__spinner').classList.remove('hidden');

  console.log("Cart Route: ", cartRoute);
  const body = JSON.stringify({
    id: `${variantId}`,
    quantity: `${newQty}`,
    sections: ["cart-notification-product","cart-notification-button","cart-icon-bubble","card-product"],
    sections_url: window.location.pathname,
  });

  fetch(`${cartRoute}`, { ...fetchConfig(), ...{ body } })
    .then((response) => {
      if (!response.ok) {
          return response.json().then(errorBody => Promise.reject(errorBody));
      }
      return response.text();
    })
    .then((state) => {
      const parsedState = JSON.parse(state);
      let parseHTML = parsedState.sections["card-product"];
      //console.log("parsed: ",parseHTML);
      let buttonHTML = getButtonHTML(variantId, parseHTML);
      //console.log("button: ",buttonHTML);
      let cardProductTarget = document.querySelector(`.card-product-${variantId}`);
      let buttonTarget = cardProductTarget.querySelector('.product-form__buttons');
      buttonTarget.innerHTML = buttonHTML;
      submitButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
      submitButton.classList.remove("loading");
      document.querySelector('#cart-icon-bubble').innerHTML = parsedState.sections["cart-icon-bubble"];
      const minusButtons = document.querySelectorAll(".button-minus-qty");
      const plusButtons = document.querySelectorAll(".button-plus-qty");
      const checkoutButtons = document.querySelectorAll(".quick-add__submit");
      
      minusButtons.forEach(button => {
        button.addEventListener("click", handleButtonClick);
      });
      
      plusButtons.forEach(button => {
        button.addEventListener("click", handleButtonClick);
      });

      checkoutButtons.forEach(button => {
        button.addEventListener("click", handleButtonClick);
      });
    })
    .catch((errorBody) => {
        if (errorBody) {
            const errorMsg = errorBody.errors;
            const variantId = event.target.getAttribute('data-vid');
            const errorBox = document.querySelector(`.product-form__error-message-wrapper-${variantId}`);
            errorBox.classList.remove("hidden");
            errorBox.removeAttribute("hidden");
            const errorText = errorBox.querySelector(".product-form__error-message");
            errorText.innerHTML = errorMsg;
            submitButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
            submitButton.classList.remove("loading");
        }
    });
}

function getButtonHTML(variantId, htmlString) {

  let parser = new DOMParser();
  let doc = parser.parseFromString(htmlString, 'text/html'); 
  let cardProduct = doc.querySelector(`.card-product-${variantId}`);
  
  if (cardProduct) {
    let productFormButtons = cardProduct.querySelector('.product-form__buttons');
    
    if (productFormButtons) {
      return productFormButtons.innerHTML;
    }
  }
  return null;
}
**/

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  console.log('main product section');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pre-cart-upsells"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    var addButton = document.querySelector('.upsell-wrapper #add_all_recommended');
    addButton.addEventListener('click', async function(e) {
      e.preventDefault();
      this.style.opacity = '0.65';
      this.innerHTML = 'Adding...';

      var variantId = this.getAttribute('data-bundle');
      var bundleRoute = this.getAttribute('data-route');
      var quantity = 1;

        try {
            // Await the AJAX call
            await $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: {
                    id: variantId,
                    quantity: quantity
                },
                dataType: 'json'
            });
            // After the AJAX call is successful
            addButton.textContent = 'Added! ✓';
            addButton.style.opacity = '1';
            // Allow UI to update before redirecting
            setTimeout(function() {
                window.location.href = '/checkout';
            }, 100); // Adjust delay as needed
        } catch (error) {
            console.error("Error:", error.statusText || "An error occurred");
            // Handle error, potentially update button text to indicate failure
            addButton.textContent = 'Add to Cart';
            addButton.style.opacity = '1';
        }
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["usp-bar-swiper"] && !window.DesignMode) return;
  try {
    
let swiperInstancesMob = [];
let swiperInstancesDtp = [];

// Initialize Swiper instances
let swiperMob = document.querySelector('.usp-mob');
let swiperDtp = document.querySelector('.usp-dtp');
let swiperContainersMob = swiperMob.querySelectorAll('.swiper-container');
let swiperContainersDtp = swiperDtp.querySelectorAll('.swiper-container');

swiperContainersMob.forEach((container, index) => {
  let swiper = new Swiper(container, {
    direction: 'vertical',
    slidesPerView: 1,
    autoplay: false, // Turn off internal autoplay
    loop: true
  });

  // Push the instance into the array
  swiperInstancesMob.push(swiper);
});

swiperContainersDtp.forEach((container, index) => {
  let swiper = new Swiper(container, {
    direction: 'vertical',
    slidesPerView: 1,
    autoplay: false, // Turn off internal autoplay
    loop: true
  });

  // Push the instance into the array
  swiperInstancesDtp.push(swiper);
});

// Define a function for starting autoplay
let autoplayMob = () => {
  swiperInstancesMob.forEach((swiper, index) => {
    setTimeout(() => {
      swiper.slideNext(); // Slide to next slide
    }, index * 205); // Set the delay between each transition
  });
};

let autoplayDtp = () => {
  swiperInstancesDtp.forEach((swiper, index) => {
    setTimeout(() => {
      swiper.slideNext(); // Slide to next slide
    }, index * 205); // Set the delay between each transition
  });
};

// Start autoplay
setInterval(autoplayMob, 3000);
setInterval(autoplayDtp, 3000);

  } catch(e) { console.error(e); }
})();
})();
